import { useEffect, useMemo } from 'react';
import { getCountriesRequest } from '../containers/Country/actions.es6';
import { getCurrencyOptionsFromCountries } from '../lib/utils.es6';

// Derives the selectable currency list from the backend Country slice, and
// triggers the fetch once if nothing is loaded yet. Callers must already be
// connect()-ed to Redux and pass through `state.country` + `dispatch` — this
// stays a plain function (not useSelector/useDispatch) to match the
// connect() pattern already used by ProductForm's two host containers.
export default function useCurrencyOptions(countryState, dispatch) {
  var state = countryState || {};
  var countries = state.countries || [];

  useEffect(function() {
    if (!state.loader && countries.length === 0) {
      dispatch(getCountriesRequest());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return useMemo(function() {
    return getCurrencyOptionsFromCountries(countries);
  }, [countries]);
}
